<template>
  <div class="check-email">
    <h1 class="check-email__title">
      {{ $t('Check your e-mail') }}
    </h1>
    <h3>
      {{ $t('We’ve sent you the instructions to reset your password.') }}
    </h3>
    <p>
      {{ $t('Didn’t receive the email? Check your spam filter or ') }}
      <CustomButton
        class="check-email__resend-link"
        :text="$t('request the link again.')"
        type="link"
        @click="resendLink"
      />
    </p>
    <hr class="RB-grey-medium w-full">
    <p>{{ $t('We’ll see you back here shortly.') }}</p>
  </div>
</template>

<script lang="ts">
import CustomButton from '~/components/atoms/Buttons/Button/CustomButton.vue';


import { ROUTES } from '~~/constants/routes';
definePageMeta({
  layout: 'default-full-width',
  middleware: ['non-authenticated'],
});

export default defineComponent({
  name: 'CheckEmail',
  components: {
    CustomButton,
  },
  setup() {

    const router = useRouter();
    const { getAdjustedSlug } = useRouteExtended();

    const resendLink = () => {

      router.push(getAdjustedSlug(ROUTES.RESET_PASSWORD));
    
    };

    return {
      resendLink,
    };
  
  },
});
</script>

<style lang="scss" scoped>
.check-email {
  @apply m-auto flex max-w-4xl flex-col items-center gap-6 p-11 text-center md:p-32;

  & .check-email__title {
    @apply pb-14;
  }

  & .check-email__return-button {
    @apply font-normal no-underline;
  }

  & .check-email__resend-link {
    @apply inline w-fit p-0 font-normal no-underline;

    text-transform: lowercase;
  }
}
</style>
